import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  HStack,
  VStack,
  Spinner,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import TopMenu from "./TopMenu";
import UserLoginBox from "./UserLoginBox";
import Sidebar from "./Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Header = ({ toggleSidebar, isOpen, onThemeChange }) => {
  const navigate = useNavigate();
  const { sessionId, login: isLoggedIn, profile, isLoading } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const fontSize = "clamp(0.7rem, 1.8vw, 1.1rem)";
  const subFontSize = "clamp(0.6rem, 1.8vw, .9rem)";


  useEffect(() => {
    if (!profile.OfficeID) {
      setIsStaff(false);
    } else {
      setIsStaff(true);
    }
  }, [profile]);
  // ตรวจสอบ breakpoint
  const isDesktop = useBreakpointValue({ base: false, md: true });

  useEffect(() => {
    if (isDesktop && isSidebarOpen) {
      setIsSidebarOpen(false); // ปิด Sidebar ในโหมด desktop
    }
  }, [isDesktop, isSidebarOpen]);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  console.log("AuthContext in Header:", { sessionId, isLoggedIn, profile, isLoading });

  return (
    <>
      {/* ใช้ bgGradient และเพิ่ม padding ด้านบนและล่าง (py) */}
      <Box
        bgGradient="linear(to-r, primary.800, primary.900)" // ใช้สีจาก theme
        w="full"
        py={{ base: 2, md: 3 }} // ปรับ Padding ให้เหมาะสม
        px={{ base: 3, md: 4 }}
        position="fixed"
        top="0"
        zIndex="docked"
        boxShadow="md"
      >
        <Flex align="center" justify="space-between">
          {/* ... (ส่วน Logo และชื่อหน่วยงานเหมือนเดิม) ... */}
          <HStack spacing={{ base: 2, md: 2 }}>
            {!isStaff ?
              <Image
                src="/logo.png"
                alt="Logo"
                boxSize={{ base: "40px", md: "50px" }}
              />
              :
              <Image
                src="/logo.png"
                alt="Logo"
                boxSize={{ base: "40px", md: "50px" }}
              />
            }
            <VStack spacing={0} align="start" display={{ base: "none", md: "flex" }}>
              <Heading
                fontSize={fontSize}
                fontWeight="bold"
                color="white"
                whiteSpace="nowrap"
              >
                {isStaff ? "ระบบบริหารจัดการคลังวัคซีน" : "ระบบสั่งจองวัคซีนออนไลน์"}
              </Heading>
              <Heading
                fontSize={subFontSize}
                fontWeight="bold"
                color="white"
                whiteSpace="nowrap"
              >
                สำนักเทคโนโลยีชีวภัณฑ์สัตว์
              </Heading>
            </VStack>
          </HStack>

          {/* TopMenu */}
          <Box display={{ base: "none", md: "block" }} flex="1" mx={4}>
            <TopMenu />
          </Box>

          {/* Hamburger Menu และ UserLoginBox */}
          <HStack spacing={2}>
            <Box display={{ base: "block", md: "none" }}>
              <IconButton
                icon={<FontAwesomeIcon icon={faBars} />}
                aria-label="Open Menu"
                variant="ghost"
                colorScheme="iconMenuScheme" // ใช้ color scheme จาก theme
                onClick={handleToggleSidebar}
              />
            </Box>
            {isLoading ? <Spinner size="sm" color="white" /> : <UserLoginBox />}
          </HStack>
        </Flex>
      </Box>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
    </>
  );
}
export default Header;